module.exports = __webpack_public_path__ + "img/motion01.eb7ba2b3.jpg";